<template>
  <div>
    <modal
      modal-type="bottom-sheet"
      modal-Id="about"
      v-bind:modal-visible="aboutVisible">
      <template slot="toolbar-title">
        <div class="f-title">About BCFireMap.com</div>
        <div class="c-title">
          <a href="mailto:bcfiremap@gmail.com" target="_blank">BCFireMap@gmail.com</a>
        </div>
      </template>

      <template slot="body">
        <div
          id="rg-about-body"
          ref="aboutViewBody">
          <div class="text-block">
            <h1>Legal Stuff: </h1>
            <h4>Always defer to, and verify information with official government sources.</h4>
            <p>This application based on opensource technologies and open data from NASA,
               NOAA, ESRI, the BC Goverment and GeoMet Canada.
                This data is subject to updates and accuracy from these open sources.</p>
            <p>BCFireMap's aim is to assist in wildfire and emergency adapatation for
               those living in, and travel in, BC's changing climate.</p>
            <p>By closing this informational dialog you acknowledge
              that the <b>creator of this mapping application,
              <a href="mailto:bcfiremap@gmail.com" target="_blank">Neil Johnston</a>,
               is not responsible for the accuracy of the information displayed</b>
               in this application.</p>
          </div>
          <div
            v-for="(item, index) in updates"
            :key="index"
            class="text-block">
            <h3 v-text="sanitize(item.title)"></h3>
            <span v-html="sanitize(item.body)"></span>
          </div>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
/* eslint-disable no-trailing-spaces */
/* eslint-disable max-len */
import Insane from 'insane';

import { mapState, mapActions } from 'vuex';
import modal from './modal.vue';


export default {
  name: 'AboutView',

  components: {
    modal,
  },

  data() {
    return {
      aboutViewState: false,
      error: false,
    };
  },

  created() {
    this.$bus.$on('modal-close-event', this.closeView);
    this.$bus.$on('open-about-view', this.showView);
  },

  beforeDestroy() {
    this.$bus.$off('modal-close-event');
  },

  computed: {
    ...mapState([
      'aboutVisible',
      'updates',
    ]),
  },

  watch: {
    
  },

  methods: {
    ...mapActions([
      'setAboutVisible',
      'setUpdatesLastChecked',
    ]),

    sanitize(str) {
      return Insane(str,
        {
          allowedTags: ['h3', 'p', 'a', 'ul', 'li', 'br'],
          allowedAttributes: {
            a: ['href', 'target'],
            p: ['align'],
          },
        });
    },

    closeView() {
      this.setAboutVisible(false);
      this.setUpdatesLastChecked();
    },

    showView() {
      this.setAboutVisible(true);
    },
  },

};
</script>

<style lang="less">
div#rg-about-body {
    margin-left: 32px;
    margin-right: 32px;
    padding-bottom: 78px;
}
h1, h2, h3, h4 {
  margin: 16px;
}

p {
  margin: 16px;
}
ul {
  margin: 10px 30px;
}
.text-block {
  border-bottom: 1px solid orange;
  margin-bottom: 32px;
}
.rg-toolbar-content {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-content: center;
  justify-content: space-between;
}

.c-title {
  // font-size: 0.8em;
  // margin-right: 16px;
  // text-align: right;
  a {
    color: white;
    text-decoration: none;
  }
}
</style>
